import { useState, useCallback, useEffect } from "react";
import { useConfig } from "./useConfig";
import { LotterySessionDto } from "../models/Lottery";
import { useSnackbar } from "notistack";

export const useLotteries = () => {
  const [lotteries, setLotteries] = useState<LotterySessionDto[]>([]);
  const [loading, setLoading] = useState(false);
  const { config } = useConfig();
  const { enqueueSnackbar } = useSnackbar();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${config.apiUrl}/lottery/sessions/all`, {
        method: "GET",
      });

      if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`);
      }
      const json = (await res.json()) as any;
      setLotteries(json);
    } catch (err) {
      enqueueSnackbar(`${err}`, {
        variant: "error",
        autoHideDuration: 4000,
      });
    } finally {
      setLoading(false);
    }
  }, [config.apiUrl, enqueueSnackbar]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { lotteries, loading, refetch: fetchData };
};
